// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"us","left":"ut","center":"uu","right":"uv"};